import { LifeType } from "../models/LifeType";
import { useLifeTypes } from "./useLifeTypes";

const useLifeType = (id: LifeType["id"]): LifeType | null => useLifeTypes()?.find(lt => lt.id === id) ?? null;

export default useLifeType;
export { useLifeType };
